/* @jsx mdx */
import React from 'react';
import { mdx } from '@mdx-js/react'
/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};
const SectionTitle = makeShortcode("SectionTitle");
const ExternalLink = makeShortcode("ExternalLink");
const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <SectionTitle mdxType="SectionTitle">Further Reading</SectionTitle>
    <p>
  <ExternalLink href="https://github.com/DefinitelyTyped/DefinitelyTyped" mdxType="ExternalLink">
    DefinitelyTyped
  </ExternalLink>
  <br />
  <ExternalLink href="https://zhuanlan.zhihu.com/p/58123993" mdxType="ExternalLink">
    快速编写第三方包 .d.ts 类型声明指南
  </ExternalLink>
    </p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
